import React, { useMemo, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTable, useSortBy, useFilters, useGlobalFilter } from "react-table";
import "./LiveBedCapacity.css";
import "./Table.css";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { FaHospitalAlt } from "react-icons/fa";
import { hospitalTypes } from "./BedCapacityConstants";
import { useMediaQuery } from "react-responsive";
import ProgressBar from "../../services/ProgressBar";
import "react-widgets/styles.css";
// import {
//   ArrowDownward,
//   ArrowUpward,
//   TrendingDown,
//   TrendingUp,
// } from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    height: "30px",
    color: "rgb(8,87,97)",
  },
  text: {
    marginLeft: "-20px",
    fontStyle: "bold",
  },
  icon: {
    color: "rgb(8,87,97)",
    marginLeft: "-10px",
  },
  namefilter: {
    "& .MuiFilledInput-root": {
      background: "#DEE2E6",
    },
    size: "small",
  },
});

const ITEM_HEIGHT = 58;
const ITEM_PADDING_TOP = 6;
const MenuProps = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "250px",
    },
  },
};
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  );
}
const MultipleFilter = (rows, filler, filterValue) => {
  const arr = [];
  rows.forEach((val) => {
    if (filterValue.includes(val.original.HOSPITAL_TYPE)) arr.push(val);
  });
  return arr;
};

export default function OverviewTable({ data }) {
  // console.log(data, "filteredData");
  const [filterInput, setFilterInput] = useState("");
  const classes = useStyles();
  const [hospitalTypeFilterInput, setHospitalTypeFilterInput] =
    useState(hospitalTypes);
  const isMobileDevice = useMediaQuery({
    query: "(max-device-width: 480px)",
  });
  const isTabDevice = useMediaQuery({
    query: "(max-device-width: 1150px) ",
  });

  const isAllHospitalTypeSelected =
    hospitalTypes.length > 0 &&
    hospitalTypeFilterInput?.length === hospitalTypes.length;
  const handleFilterChange = (e) => {
    const value = e.target.value || undefined;
    setFilter("HOSPITAL_NAME", value);
    setFilterInput(value);
  };

  const handleHospitalTypeChange = (e) => {
    const value = e.target.value || undefined;
    if (value[value.length - 1] === "all") {
      setHospitalTypeFilterInput(
        hospitalTypeFilterInput?.length === hospitalTypes.length
          ? []
          : hospitalTypes
      );
      setFilter(
        "HOSPITAL_TYPE",
        hospitalTypeFilterInput?.length === hospitalTypes.length
          ? []
          : hospitalTypes
      );
      return;
    }
    setFilter("HOSPITAL_TYPE", value);
    setHospitalTypeFilterInput(value);
  };
  const handleHospitalTypeChange2 = (v) => {
    const value = v || undefined;
    if (value[value.length - 1] === "all") {
      setHospitalTypeFilterInput(
        hospitalTypeFilterInput?.length === hospitalTypes.length
          ? []
          : hospitalTypes
      );
      setFilter(
        "HOSPITAL_TYPE",
        hospitalTypeFilterInput?.length === hospitalTypes.length
          ? []
          : hospitalTypes
      );
      return;
    }
    setFilter("HOSPITAL_TYPE", value);
    setHospitalTypeFilterInput(value);
  };
  const columns = useMemo(
    () => [
      {
        // first group - TV Show
        Header: "Hospital Name",
        accessor: "HOSPITAL_NAME",
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          return (
            <strong>
              {value}
            </strong>
          );
        },
      },
      {
        // first group - TV Show
        Header: "Trauma Levels",
        accessor: "TRAUMA_LEVEL",
        disableFilters: true,
        // First group columns
      },
      {
        // first group - TV Show

        Header: "Hospital Type",
        accessor: "HOSPITAL_TYPE",
        disableFilters: true,
        filter: MultipleFilter,
        // First group columns
      },
      {
        // first group - TV Show
        Header: "Overall",
        tipText: `Inpatient beds made up of Adult and Pediatric Intensive Care, Adult Medical/Surgical, Pediatric, Neonatal, Psychiatric, Labor/Delivery. 
        Does NOT include ER, Burn, Airborn Infection, Nursery, or NICU Beds.`,
        // First group columns
        columns: [
          {
            Header: "Total Staffed Beds*",
            accessor: "Staffed All Beds",
            disableFilters: true,
          },
          // {
          //   Header: "Total Staffed Beds HIE",
          //   accessor: "Staffed All Beds HIE",
          //   disableFilters: true,
          // },
          {
            Header: "Total Occupied Beds",
            accessor: "Occupied All Beds",
            id: "occupiedBeds",
            disableFilters: true,
          },
          {
            Header: "Total Beds Available",
            accessor: "Available All Beds",
            disableFilters: true,
          },
          {
            Header: "Percentage Occupied",
            accessor: "Percentage Occupied All Beds",
            disableFilters: true,
            Cell: ({ cell: { value } }) => {
              if (value == "-" || value == null) {
                return "-";
              } else if (Math.floor(value) >= 80 && Math.floor(value) <= 100) {
                const pValueER = Math.round(value);
                return (
                  <ProgressBar
                    bgcolor="#FF7F7F"
                    completed={pValueER}
                  ></ProgressBar>
                );
              } else if (Math.floor(value) > 100) {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#FF7F7F"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              } else if (Math.floor(value) >= 60 && Math.floor(value) < 80) {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#F2E34C"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              } else {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#9AE6B4"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              }
            },
          },
        ],
      },
      {
        // Second group - Details
        Header: "ICU",
        tipText: `Inpatient beds made up of Adult and Pediatric Intensive Care.`,
        // Second group columns
        columns: [
          {
            Header: "Total Staffed ICU Beds",
            disableFilters: true,
            accessor: "Staffed ICU Beds",
          },
          {
            Header: "Total ICU Beds Occupied",
            accessor: "Occupied ICU Beds",
            disableFilters: true,
          },
          {
            Header: "Total ICU Beds Available",
            accessor: "Available ICU Beds",
            disableFilters: true,
          },
          {
            Header: "Percentage Occupied ICU",
            accessor: "Percentage Occupied ICU",
            disableFilters: true,
            Cell: ({ cell: { value } }) => {
              if (value == "-" || value == null) {
                return "-";
              } else if (Math.floor(value) >= 80 && Math.floor(value) <= 100) {
                const pValueER = Math.round(value);
                return (
                  <ProgressBar
                    bgcolor="#FF7F7F"
                    completed={pValueER}
                  ></ProgressBar>
                );
              } else if (Math.floor(value) > 100) {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#FF7F7F"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              } else if (Math.floor(value) >= 60 && Math.floor(value) < 80) {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#F2E34C"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              } else {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#9AE6B4"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              }
            },
          },
        ],
      },
      {
        //     // Third group - Details
        Header: "ER",
        tipText: `Emergency Department Beds`,
        //     // Third group columns
        columns: [
          {
            Header: "Total ER Beds",
            accessor: "Total ER Beds",
            disableFilters: true,
          },
          {
            Header: "Total ER Beds Occupied",
            accessor: "Occupied ER Beds",
            disableFilters: true,
          },
          {
            Header: "Total ER Beds Available",
            accessor: "Available ER Beds",
            disableFilters: true,
          },
          {
            Header: "Percentage Occupied ER",
            accessor: "Percentage Occupied ER Beds",
            disableFilters: true,
            Cell: ({ cell: { value } }) => {
              if (value == "-" || value == null) {
                return "-";
              } else if (Math.floor(value) >= 80 && Math.floor(value) <= 100) {
                const pValueER = Math.round(value);
                return (
                  <ProgressBar
                    bgcolor="#FF7F7F"
                    completed={pValueER}
                  ></ProgressBar>
                );
              } else if (Math.floor(value) > 100) {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#FF7F7F"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              } else if (Math.floor(value) >= 60 && Math.floor(value) < 80) {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#F2E34C"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              } else {
                const pValueER = Math.round(value);
                return (
                  <>
                    <ProgressBar
                      bgcolor="#9AE6B4"
                      completed={pValueER}
                    ></ProgressBar>
                  </>
                );
              }
            },
          },
        ],
      },
    ],
    []
  );
  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    rows, // rows for the table based on the data passed
    prepareRow,
    setFilter,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: {
        sortBy: [{ id: "occupiedBeds", desc: true }],
      },
    },

    useFilters,
    useGlobalFilter,
    useSortBy
  );

  return (
    <div>
      <div>
        <h6 className="card-header bg-light">
          <ListItem className={classes.root}>
            <ListItemIcon>
              <FaHospitalAlt size={25} className={classes.icon} />
            </ListItemIcon>
            <ListItemText disableTypography className={classes.text}>
              OCCUPANCY BY HOSPITAL
            </ListItemText>
          </ListItem>{" "}
        </h6>
        {headerGroups.map((headerGroup) => (
          <span {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <span {...column.getHeaderProps()}>
                {column.canFilter ? (
                  <span> {column.render("Filter")}</span>
                ) : null}
              </span>
            ))}
          </span>
        ))}
      </div>
      <div className={isTabDevice ? "tableWrap" : ""}>
        <table className="overview" {...getTableProps()}>
          <thead id={isTabDevice ? "" : isMobileDevice ? "" : "sticky-thc"}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    id="new-tooltip"
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={
                      column.isSorted
                        ? column.isSortedDesc
                          ? "sort-desc"
                          : "sort-asc"
                        : ""
                    }
                  >
                    {column.render("Header")}
                    {headerGroup.headers[index].tipText && (
                      <span>{headerGroup.headers[index].tipText}</span>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
